import { useGetUserHoldingQuery } from 'src/shared/api/holding';
import { useForm, useFormState } from 'react-final-form';
import { useEffect, useState } from 'react';
import { useGetCompaniesQuery } from 'src/shared/api/company';
import { useGetIntegrationDataQuery } from 'src/shared/api/integrations/factorial';
import { isEmpty } from 'lodash';
import { getIsConnected } from '../utils/getIsConnected';

const integrationName = 'factorial';

const useFactorialConnection = () => {
  const { data: holding } = useGetUserHoldingQuery();
  const { data: companies } = useGetCompaniesQuery();
  const { data: integrationData, isLoading } = useGetIntegrationDataQuery();
  const form = useForm();
  const [selectedCompany, setSelectedCompany] = useState('');
  const { values } = useFormState();
  const isConnected = getIsConnected({
    isLoading,
    integrationData,
    subsidiary: values.company,
    integrationName
  });
  const company = integrationData?.find(company => company.subsidiary === selectedCompany);

  useEffect(() => {
    if (!integrationData || !companies || !selectedCompany) {
      return;
    }

    if (company) {
      form.change('id', company?.id);
      form.change('company', company?.subsidiary);
      form.change('secret', company?.credentials?.apiKey);
      form.change('leaves', company?.parameters.leaves);
      form.change('teams', company?.parameters.teams);
      form.change('legalEntityId', company?.parameters.legalEntityId);

      if (!isEmpty(company?.fieldMap?.fieldMapping)) {
        form.change('withCustomFields', true);
        form.change('customFields', company?.fieldMap?.fieldMapping);
      } else {
        form.change('withCustomFields', false);
        form.change('customFields', null);
      }
    } else {
      form.change('id', '');
      form.change('company', selectedCompany);
      form.change('secret', '');
      form.change('leaves', []);
      form.change('teams', []);

      form.change('withCustomFields', false);
      form.change('customFields', null);
    }
  }, [integrationData, form, companies, holding?.metadata.legacyCore.taxId, selectedCompany, company]);

  return { integrationData, isLoading, setSelectedCompany, selectedCompany, isConnected };
};

export default useFactorialConnection;
